// Taken from https://github.com/jakearchibald/idb#keyval-store
import root from 'window-or-global';

let idb;
if (root.indexedDB) {
    idb = require('idb').default; // eslint-disable-line global-require
}

const dbPromise =
    idb &&
    idb.open('keyval-store', 1, upgradeDB => {
        upgradeDB.createObjectStore('keyval');
    });

export default {
    get(key) {
        return (
            dbPromise &&
            dbPromise.then(db =>
                db
                    .transaction('keyval')
                    .objectStore('keyval')
                    .get(key)
            )
        );
    },
    set(key, val) {
        return (
            dbPromise &&
            dbPromise.then(db => {
                const tx = db.transaction('keyval', 'readwrite');
                tx.objectStore('keyval').put(val, key);
                return tx.complete;
            })
        );
    },
    delete(key) {
        return (
            dbPromise &&
            dbPromise.then(db => {
                const tx = db.transaction('keyval', 'readwrite');
                tx.objectStore('keyval').delete(key);
                return tx.complete;
            })
        );
    },
    clear() {
        return (
            dbPromise &&
            dbPromise.then(db => {
                const tx = db.transaction('keyval', 'readwrite');
                tx.objectStore('keyval').clear();
                return tx.complete;
            })
        );
    },
    keys() {
        return (
            dbPromise &&
            dbPromise.then(db => {
                const tx = db.transaction('keyval');
                const keys = [];
                const store = tx.objectStore('keyval');

                // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
                // openKeyCursor isn't supported by Safari, so we fall back
                (store.iterateKeyCursor || store.iterateCursor).call(store, cursor => {
                    if (!cursor) return;
                    keys.push(cursor.key);
                    cursor.continue();
                });

                return tx.complete.then(() => keys);
            })
        );
    }
};
